import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'react-bootstrap-typeahead';

const CustomCheckbox = ({ 
  id = 'checkId', 
  label, 
  checked, 
  onChange, 
  className = '', 
  ...props 
}) => {
  return (
    <div className={`custom-checkbox ${className}`}>
      <Input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <label htmlFor={id} className='cursor-pointer text-light'>{label}</label>
    </div>
  );
};

CustomCheckbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default CustomCheckbox;
